import { useEffect, useState } from 'react';

import { Graph } from 'screens/NewDashboard/components';
import { GraphicDataRequest } from 'screens/NewDashboard/@types/graphic';
import { CardGraph } from 'screens/NewDashboard/components/Card';
import { CardDataRequest } from 'screens/NewDashboard/@types/cards';

import { MainContainer } from '../styles';

interface HiddenGraphicsProps {
  hiddenCardsData: CardDataRequest[];
  hiddenGraphicsData: GraphicDataRequest[];
}

export function HiddenGraphics({ hiddenCardsData, hiddenGraphicsData }: HiddenGraphicsProps) {
  const [cards, setCards] = useState(Array<CardDataRequest>);
  const [graphics, setGraphics] = useState(Array<GraphicDataRequest>);

  useEffect(() => {
    setCards(hiddenCardsData);
    setGraphics(hiddenGraphicsData);
  }, [hiddenCardsData, hiddenGraphicsData]);

  return (
    <MainContainer>
      {graphics.length > 0 || cards.length > 0 ? (
        <>
          <div className="gridCards">
            {cards.map(card => (
              <CardGraph key={card.title} data={card} indicatorColor={card.indicator.color} />
            ))}
          </div>
          <div className="gridGraphics">
            {graphics.map(graphic => (
              <Graph key={graphic.title} data={graphic} indicatorColor={graphic.indicator.color} hasOptions />
            ))}
          </div>
        </>
      ) : (
        <div className="noContent">
          <p>Não existem gráficos ocultos</p>
        </div>
      )}
    </MainContainer>
  );
}
